import WebRendererSetup from '@/components/Fitstation3DScan/WebRendererSetup';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { Box3, DoubleSide, Frustum, Group, Matrix4, Mesh, ShaderMaterial, Vector3 } from 'three';
import WebRenderer from '@/components/Fitstation3DScan/WebRenderer';

export default class FootBottomSetup extends WebRendererSetup {
	public render(urls: string[], isObj: boolean, canvasContainer: HTMLElement, details?: any) {
		this.shoeBottomShaderMaterial = new ShaderMaterial({
			side: DoubleSide,
			vertexShader: this.shaderData.shader_bottom_Vert(),
			fragmentShader: this.shaderData.shader_bottom_Frag()
		});

		this.shoeBottomShaderMaterial.extensions['derivatives'] = true;

		this.webRenderer.FitToElement(canvasContainer);

		this.webRenderer.RenderObjs(urls, isObj, async (obj) => {
			obj.rotateZ(-90 * 0.01745329252);
			obj.rotateX(180 * 0.01745329252);
			obj.rotateY(-90 * 0.01745329252);
			obj.rotateY(-180 * 0.01745329252);
			obj.scale.set(0.0023, 0.0023, 0.0023);
			this.webRenderer.camera.updateMatrix();
			this.webRenderer.camera.updateMatrixWorld();
			let fru2 = new Frustum().setFromMatrix(
				new Matrix4().multiplyMatrices(this.webRenderer.camera.projectionMatrix, this.webRenderer.camera.matrixWorldInverse)
			);
			let testB = new Box3().setFromObject(obj);
			if (fru2.containsPoint(testB.max) === false) {
				obj.position.setZ(-(testB.max.z + testB.min.z) / 2);
			}

			// obj.position.set(0.2, -0.6, -0.45);
			await this.SetShoeBottomMaterial(obj);
		});
	}

	private shoeBottomShaderMaterial?: ShaderMaterial;

	getControls(): OrbitControls {
		const controls = new OrbitControls(this.webRenderer.camera, this.webRenderer.renderer.domElement);
		controls.minDistance = 1.5;
		controls.enableDamping = true;
		controls.dampingFactor = 0.35;
		controls.enableZoom = false;
		// controls.minPolarAngle = 1.0;
		// controls.maxPolarAngle = 1;
		controls.autoRotate = false;
		controls.target = new Vector3(0.0, 0.0, 0);
		controls.rotateSpeed = 0.0;
		// @ts-ignore
		controls.mouseButtons['RIGHT'] = 0;
		// @ts-ignore
		controls.mouseButtons['MIDDLT'] = 0;
		controls.enablePan = false;

		controls.update();
		return controls;
	}

	onObjectsLoaded(index: number, group) {}

	sceneSetup() {}

	public async SetShoeBottomMaterial(obj: Group) {
		obj.traverse((c) => {
			if (c instanceof Mesh) {
				c.material = this.shoeBottomShaderMaterial as ShaderMaterial;
				c.geometry.dispose(); ///////////////////////// ???????????????
			}
		});
	}
}
